// 获取公司组织架构下部门信息
/**
 * 获取公司组织架构下部门信息
 * @param {any} { showUserCount = false, showUser = false }
 * showUserCount: 是否查询部门下用户数量
 * showUser: 是否查询部门下的用户
 * showMain: 是否显示主账号，null-全部显示，true-仅主账号，false-仅子账号
 * @returns {Promise}
 */
export function getDeptList({ showUserCount = false, showUser = false, showMain = null }) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/hierarchy/list',
    data: {
      showUserCount,
      showUser,
      showMain,
    },
  });
}

/**
 * 搜索部门和人员
 * @param {any} searchText
 * @returns {Promise}
 */
export function searchDeptsAndMembers(searchText) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/hierarchy/search',
    data: {
      searchText,
    },
  });
}

/**
 * 搜索角色和人员
 * @param {any} searchText
 * @returns {Promise}
 */
export function searchRolesAndMembers(searchText) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/role/search',
    data: {
      searchText,
    },
  });
}

/**
 * 查询企业管理员
 * @returns {Promise}
 */
export function getEnterpriseAdministrator() {
  return ZP.Ajax({
    url: '/api/user/manage/staff/hierarchy/info',
  });
}

/**
 * 更新企业管理员
 * @param {any} userId
 * @returns {Promise}
 */
export function updateEnterpriseAdministrator(userId) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/hierarchy/admin/update',
    data: { userId },
  });
}

/**
 * 新增子部门
 * @param {any} data { name, parentDeptId }
 * @returns {Promise}
 */
export function addSubDept(data) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/hierarchy/add',
    method: 'post',
    data,
  });
}

/**
 * 更新部门
 * @param {any} data
 * @returns {Primise}
 */
export function updateDept(data) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/hierarchy/update',
    method: 'post',
    data,
  });
}

/**
 * 删除部门
 * @param {any} deptId
 * @returns {Promise}
 */
export function deleteDept(deptId) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/hierarchy/delete',
    data: { deptId },
  });
}

/**
 * 查询部门下成员列表
 * @param {any} data
 * @returns {Promise}
 */
export function getDeptMemberList(data) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/list',
    data,
  });
}

/**
 * 获取成员详情
 * @param {any} userId
 * @returns {Promise}
 */
export function getMemberDetail(userId) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/get',
    data: { userId },
  });
}

/**
 * 更新子部门顺序
 * @param {any} { parentDeptId, deptIds }
 * @returns {Promise}
 */
export function updateSubDeptOrder(data) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/hierarchy/move',
    method: 'post',
    data,
  });
}

/**
 * 部门人员调整部门
 * @param {any} data
 * @returns {Promise}
 */
export function updateMembersDept(data) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/adjustDept',
    method: 'post',
    data,
  });
}

/**
 * 新增部门成员
 * @param {any} data
 * @returns {Primise}
 */
export function addDeptMember(data) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/add',
    method: 'post',
    data,
  });
}

/**
 * 更新部门成员
 * @param {any} data
 * @returns {Primise}
 */
export function updateDeptMember(data) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/update',
    method: 'post',
    data,
  });
}

/**
 * 删除部门成员
 * @param {any} userId
 * @returns {Promise}
 */
export function deleteDeptMember(userId) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/delete',
    data: { userId },
  });
}

/**
 * 获取角色列表
 * @returns {Promise}
 */
export function getRoleList() {
  return ZP.Ajax({
    url: '/api/user/manage/staff/role/list',
  });
}

/**
 * 获取角色信息
 * @param {any} id
 * @returns {Promise}
 */
export function getRoleInfo(roleId) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/role/get',
    data: { roleId },
  });
}

// 获取角色其它权限配置项
export function getOtherPermissionConfig() {
  return ZP.Ajax({
    url: '/api/user/manage/staff/permission/other/list',
  });
}

/**
 * 新增、更新角色信息
 * @param {any} data
 * @returns {Promise}
 */
export function updateRole(data) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/role/save',
    method: 'post',
    data,
  });
}

/**
 * 更新角色状态：启用或冻结
 * @param {any} roleId
 * @returns {Promise}
 */
export function updateRoleStatus(roleId) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/role/freeze',
    data: { roleId },
  });
}

/**
 * 删除角色
 * @param {any} roleId
 * @returns {Promise}
 */
export function deleteRole(roleId) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/role/delete',
    data: { roleId },
  });
}

/**
 * 获取角色下的成员列表
 * @returns {Promise}
 */
export function getRoleMemberList(data) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/listByRoleId',
    data,
  });
}

/**
 * 角色成员添加(可多个)
 * @param {any} data {roleId, userIds}
 * @returns {Promise}
 */
export function addRoleMembers(data) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/role/user/set',
    method: 'post',
    data,
  });
}

/**
 * 角色成员批量移除
 * @param {any} data {roleId, userIds}
 * @returns {Promise}
 */
export function deleteRoleMembers(data) {
  return ZP.Ajax({
    url: '/api/user/manage/staff/role/batchRemove',
    method: 'post',
    data,
  });
}

// 获取职位列表
export function getPositionList() {
  return ZP.Ajax({
    url: '/api/user/manage/position/list',
  });
}

// 更新职位列表
export function updatePositionList(data) {
  return ZP.Ajax({
    url: '/api/user/manage/position/save',
    method: 'post',
    data,
  });
}

// 删除职位
export function deletePosition(positionId) {
  return ZP.Ajax({
    url: '/api/user/manage/position/delete',
    data: { positionId },
  });
}
